import { render, staticRenderFns } from "./CampaingListComponent.vue?vue&type=template&id=83a7621e&"
import script from "./CampaingListComponent.vue?vue&type=script&lang=js&"
export * from "./CampaingListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports